import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  FormLabel,
  MenuItem,
  Modal,
  Select,
} from "@mui/material";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { AxiosResponse } from "axios";
import http from "../../../utils/http";
import { errorToastMessage, toastMessage } from "../../../utils/toast";
import {
  ModalBaseStyles,
  ModalHeader,
  ModalDrawerButtonStyles,
} from "../../Common/styles/modal";
import { InputWrapper, LabelStyle } from "../../Common/styles/form";
import { useAppDispatch } from "../../../Redux/hooks";
import { setParticipantToggle } from "../../../Redux/reducers/participantsSlice";

type Props = {
  openModal: boolean;
  closeModal: () => void;
  selectedParticipantIds: string[];
};

const SendScreenerModal = ({
  openModal,
  closeModal,
  selectedParticipantIds,
}: Props) => {
  const { id: studyId } = useParams();
  const dispatch = useAppDispatch();
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const [reachoutType, setReachoutType] = useState<string>("initial");

  const handleSend = async () => {
    try {
      if (selectedParticipantIds.length === 0) {
        toastMessage("warning", "Please select at least one participant");
        return;
      }

      setSubmitLoader(true);
      const payload = {
        studyId: studyId,
        participantIds: selectedParticipantIds,
        followup: reachoutType === "followup",
      };

      const res: AxiosResponse = await http.post(
        `/participants/send-screener`,
        payload
      );

      toastMessage("success", res.data.message || "Screener sent successfully");
      if (!payload.followup) {
        dispatch(setParticipantToggle());
      }
      closeModal();
    } catch (err) {
      errorToastMessage(err as Error);
    } finally {
      setSubmitLoader(false);
    }
  };

  return (
    <Modal open={openModal} onClose={closeModal}>
      <Box sx={{ ...ModalBaseStyles, minHeight: "20vh" }}>
        <ModalHeader title="Send Screener" onCloseClick={closeModal} />

        <FormControl sx={InputWrapper}>
          <FormLabel sx={LabelStyle} htmlFor="reachout-type-select">
            Reachout Type
          </FormLabel>
          <Select
            id="reachout-type-select"
            value={reachoutType}
            onChange={(e) => setReachoutType(e.target.value)}
          >
            <MenuItem value="initial">Initial Reachout</MenuItem>
            <MenuItem value="followup">Followup Reachout</MenuItem>
          </Select>
          <FormHelperText>
            The Email with the screener link will be sent to{" "}
            {selectedParticipantIds.length} selected participant
            {selectedParticipantIds.length !== 1 ? "s" : ""}
          </FormHelperText>
        </FormControl>

        <Box sx={ModalDrawerButtonStyles}>
          <Button
            onClick={closeModal}
            variant="outlined"
            disabled={submitLoader}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSend}
            variant="contained"
            disabled={submitLoader}
            startIcon={submitLoader ? <CircularProgress size={18} /> : null}
          >
            Send
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SendScreenerModal;
